import { quotationStatus } from ".";
import { Doc } from "../../_generated/dataModel";
import { FilterRule, FilterRuleCtx } from "../../lib/types/filters_types";

export const quotationStatusRule: FilterRule<Doc<"quotations">> = {
  priority: 1,
  build: async (ctx: FilterRuleCtx, args: Partial<Omit<Doc<"quotations">, "_id" | "_creationTime">>) => {
    const { userContext } = ctx;
    const status: Doc<"quotations">["status"] | undefined = args.status;

    if (!status) return undefined;

    const valid = [quotationStatus.type] as const;
    if (!valid.includes(status as any)) return undefined;

    if (!userContext?.companyId) {
      throw new Error("Usuario no tiene empresa asignada");
    }

    return ctx.db
      .query("quotations")
      .withIndex("by_company_and_status", (q) =>
        q
          .eq("internalControl.companyId", userContext.companyId!)
          .eq("status", status),
      )
      .collect();
  },
};
